import { FC, ReactNode } from 'react';

import clsx from 'clsx';

import classes from './Panel.module.scss';

export interface PanelProps {
  children?: ReactNode;
  actions?: ReactNode;
  testId?: string;
  unscrollable?: boolean;
  className?: string;
}

export const Panel: FC<PanelProps> = ({
  children,
  actions,
  testId,
  unscrollable,
  className,
}) => {
  return (
    <div className={classes.container} data-testid={testId}>
      <div
        className={clsx(
          classes.content,
          unscrollable && classes.unscrollable,
          className,
        )}
      >
        {children}
      </div>
      {actions && <div className={classes.actions}>{actions}</div>}
    </div>
  );
};
